module.exports = __webpack_public_path__ + "img/ChainHomeSignIn.1d7df348.jpeg";